





















































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto'
import AgencyUserCreate from '@/components/AgencyUsers/AgencyUserCreate.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import AgencyUserStatus from '@/components/AgencyUsers/Display/AgencyUserStatus.vue';
import PageNames from '@/router/PageNames';

@Component({
  name: 'AgencyUsers',
  components: { AgencyUserCreate, AgencyUserStatus }
})
export default class extends GiganautVue {

    private search = '';

    private headers = [
        { text: '', value: 'avatar', sortable: false },
        { text: 'Name', value: 'person.firstName' },
        { text: 'Email', value: 'emailAddress' },
        { text: 'Branch', value: 'defaultBranch.brandName' },
        { text: 'Desk', value: 'defaultDesk.name' },
        { text: 'Manager', value: 'manager.person.firstName' },
        { text: 'Status', value: 'status' },
    ];

    get agencyUsers() {
        return AgencySettingsModule.agencyUsers;
    }

    getUserAvatarUrl(user: AgencyUserDto) {
        return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/2/" + user.id + "/resized-100/" + user.avatar;
    }

    getBranchName(user: AgencyUserDto) {
        if (user.defaultBranch == null) return '';
        return user.defaultBranch.brandName;
    }

    getDeskName(user: AgencyUserDto) {
        if (user.defaultDesk == null) return '';
        return user.defaultDesk.name;
    }

    navigateToUser(user: AgencyUserDto) {
        this.$router.push({ name: PageNames.AgencyUserDetails, params: { userid: user.id } });
    }
}
